var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-chip',{attrs:{"color":_vm.chipColor,"large":_vm.buttonSize === 'large',"small":_vm.buttonSize === 'small',"text-color":_vm.chipTextColor,"label":""}},[_c('v-avatar',[_c('v-icon',{staticClass:"ml-0 mr-2",attrs:{"small":""}},[_vm._v(_vm._s(_vm.chipIcon))])],1),_vm._v("\n    "+_vm._s(_vm.$t(_vm.chipLabel))+"\n  ")],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01612a1b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chips/StatusChip.vue
// module id = null
// module chunks = 